import { TableBody } from '@mui/material';
import { NsnReport } from '@physna/core/domain/nsn-report/nsn-report';
import { StyledTable, StyledTableCell, StyledTableRow } from './NsnTable';

export const TechnicalCharacteristicsTable = ({
  technicalCharacteristics,
}: Pick<NsnReport, 'technicalCharacteristics'>) => {
  return (
    <StyledTable size='small'>
      <TableBody>
        {technicalCharacteristics.map((characteristic, index) => (
          <StyledTableRow key={`technical-${characteristic.key}-${index}`}>
            <StyledTableCell>{characteristic.key}</StyledTableCell>
            <StyledTableCell>{characteristic.value}</StyledTableCell>
          </StyledTableRow>
        ))}
      </TableBody>
    </StyledTable>
  );
};
